import { createFileRoute } from "@tanstack/react-router";
import { HsePage, hseHead } from "@/pages/HsePage";

export const Route = createFileRoute("/en/hse-management")({
  head: () => hseHead("en"),
  component: () => <HsePage locale="en" />,
});
